import RequestManager, {SafePromise} from '@/request_manager'
import * as T from './types/api'
import { GlobalPref, State as PrefState } from '@/store/modules/pref'
import { $s } from '@/store'

export default class API {
  public reqMan: RequestManager
  constructor (reqMan?: RequestManager) {
    console.log('Create API object')
    if (reqMan) {
      this.reqMan = reqMan
    } else {
      this.reqMan = new RequestManager()
    }
  }
  // Login is required
  public getCurrentUserPreference () {
    return this.reqMan.get('/preference') as SafePromise<null|object>
  }
  public setCurrentUserPreference (pref: PrefState) {
    return this.reqMan.post('/preference', pref) as SafePromise<PrefState>
  }
  public getExtenderList () {
    return this.reqMan.rpcCall('Extender.GetAll') as SafePromise<T.Extender[]>
  }
  public setDeviceName (param: T.ApiParamSetDeviceName) {
    return this.reqMan.rpcCall('Extender.SetDeviceName', param) as SafePromise<T.ApiReturnCode>
  }
  public rebootDevice (param: T.ApiDeviceMacParam) {
    return this.reqMan.rpcCall('Extender.Reboot', param) as SafePromise<T.ApiReturnCode>
  }
  public resetDevice (param: T.ApiDeviceMacParam) {
    return this.reqMan.rpcCall('Extender.Reset', param) as SafePromise<T.ApiReturnCode>
  }
  /** Set the rx tx matrix mapping */
  public matrixJoin (param: T.ApiParamMatrixJoin) {
    return this.reqMan.rpcCall('Extender.MatrixJoin', param) as SafePromise<T.ApiReturnCode>
  }
  public setLedBlink (param: T.ApiGenericDeviceParam<boolean>) {
    return this.reqMan.rpcCall('Extender.SetLEDBlink', param) as SafePromise<T.ApiReturnCode>
  }
  public setDisableAvOutput (param: T.ApiGenericDeviceParam<boolean>) {
    return this.reqMan.rpcCall('Extender.SetDisableAVOutput', param) as SafePromise<T.ApiReturnCode>
  }
  public getSystemBasicInfo () {
    return this.reqMan.rpcCall('System.GetBasicInfo') as SafePromise<T.SystemBasicInfo>
  }
  public getSystemNetworkStatus () {
    return this.reqMan.rpcCall('System.GetNetworkStatus') as SafePromise<T.SystemNetwork>
  }
  public getSystemNetworkSetting () {
    return this.getSystemNetworkStatus()
    // return this.reqMan.rpcCall('System.GetNetworkSetting') as SafePromise<T.SystemNetwork>
  }
  public setSystemNetworkSetting (param: T.SystemNetwork) {
    return this.reqMan.rpcCall('System.SetNetwork', param) as SafePromise<T.ApiReturnCode>
  }
  public getVwList () {
    return this.reqMan.rpcCall('VideoWall.GetAll') as SafePromise<T.ApiVw[]>
  }
  public setOrCreateVw (param: T.ApiVw) {
    return this.reqMan.rpcCall('VideoWall.Set', param) as SafePromise<T.ApiReturnCode>
  }
  public vwApply (param: T.ApiVwBaseParam) {
    return this.reqMan.rpcCall('VideoWall.Apply', param) as SafePromise<T.ApiReturnCode>
  }
  public vwDelete (param: T.ApiVwBaseParam) {
    return this.reqMan.rpcCall('VideoWall.Delete', param) as SafePromise<T.ApiReturnCode>
  }
  public vwApplyRxIndexOsd (param: T.ApiGenericVwParam<boolean>) {
    return this.reqMan.rpcCall('VideoWall.ApplyRXIndexOSD', param) as SafePromise<T.ApiReturnCode>
  }
  public vwPreviewStart (param: T.ApiVw) {
    return this.reqMan.rpcCall('VideoWall.Preview', param) as SafePromise<T.ApiReturnCode>
  }
  public vwPreviewRestore () {
    return this.reqMan.rpcCall('VideoWall.RestorePreview') as SafePromise<T.ApiReturnCode>
  }
  public getOsdList () {
    return this.reqMan.rpcCall('OSD.GetAll') as SafePromise<T.OsdConfig[]>
  }
  /** Nonexistent id means create; otherwise, update existed */
  public createOrUpdateOsd (param: T.OsdConfig) {
    return this.reqMan.rpcCall('OSD.Set', param) as SafePromise<T.ApiReturnCode>
  }
  public deleteOsd (param: T.ApiParamDeleteOsd) {
    return this.reqMan.rpcCall('OSD.Delete', param) as SafePromise<T.ApiReturnCode>
  }
  public setExtenderOsd (param: T.ApiParamSetExtenderOsd) {
    return this.reqMan.rpcCall('Extender.ApplyOSD', param) as SafePromise<T.ApiReturnCode>
  }
  public uploadOsdImage (param: T.ApiUploadOsdImage): Promise<boolean> {
    // https://stackoverflow.com/questions/4526273/what-does-enctype-multipart-form-data-mean
    // "When you are writing client-side code, all you need to know is use multipart/form-data
    // when your form includes any <input type="file"> elements."
    const form = new FormData()
    form.append('id', param.id + '')
    form.append('image', param.image)
    return this.reqMan.post('/osd-image-upload', form, {
      headers: {
        enctype: 'multipart/form-data'
      }
    }).then(() => true).catch(() => false)
  }
  public getOsdImageList () {
    return this.reqMan.rpcCall('Image.GetAll') as SafePromise<T.OsdImage[]>
  }
  /** Nonexistent id means create; otherwise, update existed */
  public createOrUpdateOsdImgCfg (param: T.OsdImage) {
    return this.reqMan.rpcCall('Image.Set', param) as SafePromise<T.ApiReturnCode>
  }
  public deleteOsdImage (param: T.ApiParamDeleteOsdImage) {
    return this.reqMan.rpcCall('Image.Delete', param) as SafePromise<T.ApiReturnCode>
  }
  public createOrUpdatePreset (param: T.Preset) {
    return this.reqMan.rpcCall('Preset.Set', param) as SafePromise<T.ApiReturnCode>
  }
  public getPresetList () {
    return this.reqMan.rpcCall('Preset.GetAll') as SafePromise<T.Preset[]>
  }
  public deletePreset (param: T.ApiParamDeletePreset) {
    return this.reqMan.rpcCall('Preset.Delete', param) as SafePromise<T.ApiReturnCode>
  }
  public applyPreset (param: T.ApiParamDeletePreset) {
    return this.reqMan.rpcCall('Preset.Apply', param) as SafePromise<T.ApiReturnCode>
  }
  // =======================================================================
  // =======================================================================
  // =======================================================================
  // =======================================================================
  // Following are all deprecated
  // =======================================================================
  // =======================================================================
  // =======================================================================
  // =======================================================================
  // ======================================================
  // Matrix
  // ======================================================

  /**
   *  Get the video snapshot data
   *  DEPRECATED: Use a fixed & regular path for each MAC address instead
   */
  public getSnapshot (): SafePromise<T.ModelSnapshot[]> {
    return this.reqMan.rpcCall('APIAutoAVSetting.GetSnapShot') as SafePromise<T.ModelSnapshot[]>
  }
  /** Load the preset as the current extender mapping */
  public setCurrentExtenderMapping (param: T.ApiParamSetCurrentExtenderMapping): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetCurrentExtenderMapping', param) as SafePromise<T.ApiReturnCode>
  }
  /** Swich the rx client source */
  public setExtenderClientSource (param: T.ApiParamSetExtenderClientSource): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderClientSourceCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Switch the CEC value of extender */
  public setExtenderCEC (param: T.ApiParamSetExtenderCEC): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderCECCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Mute the extender HDMI */
  public setExtenderHDMIMute (param: T.ApiParamSetExtenderMute): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderHDMIMuteCommand', param) as SafePromise<T.ApiReturnCode>
  }
  // ======================================================
  // Video Wall
  // ======================================================
  /** Set videoWall config active or inactive */
  public setActiveVWConfig (param: T.ApiSetActiveVW): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetActiveVideoWallConfig', param) as SafePromise<T.ApiReturnCode>
  }
  /** Delete a videowall config */
  public deleteExtenderVWConfig (param: T.VWName): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.DeleteExtenderVideoWallConfig', param) as SafePromise<T.ApiReturnCode>
  }
  /** Set the OSD config in the videowall config */  // FIXME: Wait for new API
  public setVWOSDConfig (param: T.ApiParamSetVwOsdConfig): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetVideoWallOSDConfig', param) as SafePromise<T.ApiReturnCode>
  }
  /** Update single videowall config to extender */  // FIXME: Wait for new API
  public updateExtenderVWConfig (param: T.ApiVw): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.UpdateExtenderVideoWallConfig', param) as SafePromise<T.ApiReturnCode>
  }
  // ======================================================
  // OSD
  // ======================================================
  /** Set osd mapping to rx  */
  public setExtenderOSDMapping (param: T.ApiParamOsdMapping): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderOSDMappingCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Add a photo to the OSD config
   * @param {string} param: The path that `/upload` return
   */
  public addUserOSDPhoto (param: string): SafePromise<string[]> {
    return this.reqMan.rpcCall('APIAutoAVSetting.AddUserOSDPhoto', param) as SafePromise<string[]>
  }
  /** Get all the exist user OSD photo names */
  public getUserOSDPhoto (): SafePromise<string[]> {
    return this.reqMan.rpcCall('APIAutoAVSetting.GetUserOSDList') as SafePromise<string[]>
  }
  /** Delete existing user OSD photo */
  public deleteUserOSDPhoto (photoName: string): SafePromise<any> {
    return this.reqMan.rpcCall('APIAutoAVSetting.DeleteUserOSDPhoto', photoName) as SafePromise<any>
  }
  /** Set the extender osd resolution */
  public setExtenderResolution (param: T.ApiParamSetExtenderResolution): SafePromise<any> {  // TODO: returned type?
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderResolutionCommand', param) as SafePromise<any>  // TODO: returned typ
  }
  // ======================================================
  // Setup
  // ======================================================
  /** Set extender LED flash */
  public setExtenderLEDFlashCommand (param: T.ApiGenericDeviceParam<boolean>): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderLEDFlashCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Set extender screenshot path, for switch icon, not the snapshot of the real video. */
  public setExtenderScreenShot (param: T.ApiGenericDeviceParam<string>): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderScreenShot', param) as SafePromise<T.ApiReturnCode>
  }
  /** Set extender device name */
  public setExtenderDeviceNameCommand (param: T.ApiGenericDeviceParam<string>): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderDeviceNameCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** This is the command for ITE, might be unnecessary for this customized version */
  public setExtenderInfoDisplayModeCommand (param: T.ApiGenericDeviceParam<number>): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderInfoDisplayModeCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Set upScale mode of extender */
  public setExtenderUpScaleCommand (param: T.ApiGenericDeviceParam<T.UpScaleMode>): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderUpScaleCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** (TX only) Set the video out mode (Loop-out) of tx extender */
  public setExtenderVideoOutCommand (param: T.ApiGenericDeviceParam<T.VideoOutMode>): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderVideoOutCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Set extender reboot */
  public setExtenderRebootCommand (param: T.ApiDeviceMacParam): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderRebootCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Set extender factory default */
  public setExtenderFactoryResetCommand (param: T.ApiDeviceMacParam): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderFactoryResetCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Set extender hdmi reconnect */
  public setExtenderHdmiReconnectCommand (param: T.ApiDeviceMacParam): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderHdmiReconnectCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Set extender edid mode */
  public setExtenderEDIDCommand (param: T.ApiParamExtenderEDID): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('APIAutoAVSetting.SetExtenderEDIDCommand', param) as SafePromise<T.ApiReturnCode>
  }
  /** Save Preference for current logged-in user */
  public setPreference (param: GlobalPref): SafePromise<T.ApiReturnCode> {
    return this.reqMan.rpcCall('User.SetPreference', param) as SafePromise<T.ApiReturnCode>
  }
}
